<template>
    <div style="width: 100%;">
        <v-toolbar flat color="white">
            <v-toolbar-title class="grey--text">Configuraciones</v-toolbar-title>
            <v-spacer />
            <v-dialog v-model="dialog" max-width="600px" persistent>
                <FormConfiguracion v-if="dialog" :item="editItem" @close="dialog = false" @save="saveItem" />
            </v-dialog>
        </v-toolbar>
        <v-tabs background-color="primary" dark>
            <v-tab v-for="(item, index) in encabezados"
                   :key="`tab-${index}`"
                   @click="changeConfig(item.id)">{{item.nombre}}</v-tab>
        </v-tabs>
        <v-data-table :headers="headers" :items="configuraciones"
                      :options.sync="options" :sort-by="['label']" :sort-desc="[false, true]"
                      class="elevation-1" no-data-text="No hay registros disponibles"
                      no-results-text="No hay registros disponibles"
                      :loading="loading" :server-items-length="configuracionesTotal"
                      @update:options="listar">
            <template v-slot:item.value="{item}">
                <template v-if="item.settings.type == 'password'">
                    {{item.value.slice(0, -15)}}***************
                </template>
                <template v-else-if="item.settings.type == 'boolean'">
                    {{Number.parseInt(item.value) ? 'Sí' : 'No'}}
                </template>
                <template v-else>
                    {{item.value}}
                </template>
            </template>
            <template v-slot:item.actions="{item}">
                <v-icon small class="mr-2" @click="editItemId(item.id)">
                    edit
                </v-icon>
                <!--<v-icon
                    v-if="item.id !== 0"
                    small
                    @click="deleteItemConfirm(item)"
                >
                    delete
                </v-icon>-->
            </template>
        </v-data-table>
        <v-dialog v-model="dialog_delete" max-width="750px" persistent>
            <v-card>
                <v-card-title>
                    <span class="headline">Eliminar registro</span>
                </v-card-title>
                <v-card-actions>
                    <v-spacer />
                    <v-btn color="gray darken-1" @click="dialog_delete = false">
                        No
                    </v-btn>
                    <v-btn color="red darken-1" class="white--text" :loading="loading_delete" :disabled="loading_delete" @click="deleteItem">
                        Si
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import axios from 'axios';
    import FormConfiguracion from "../../components/FormConfiguracion";

    export default {
        name: "ConfiguracionesPage",
        components: {
            FormConfiguracion
        },
        data: () => ({
            dialog: false,
            dialog_delete: false,
            headers: [
                {
                    text: 'Descripción',
                    align: 'left',
                    sortable: false,
                    value: 'label'
                },
                {
                    text: 'Valor',
                    align: 'left',
                    sortable: false,
                    value: 'value'
                },
                {
                    text: 'Opciones',
                    value: 'actions',
                    sortable: false,
                    width: '150px'
                }
            ],
            configuraciones: [],
            configuracionesTotal: 0,
            itemSelectId: 0,
            itemDelete: null,
            loading: false,
            loading_delete: false,
            options: {
                descending: true,
                page: 1,
                itemsPerPage: 10,
                totalItems: 0,
                group_by: 1
            },
            snackbar: false,
            snackbar_config: {
                color: '',
                multi_line: false,
                timeout: 6000,
                mobile: false,
                text_content: ''
            },
            encabezados: []
        }),
        computed: {
            editItem() {
                if (this.itemSelectId) {
                    return this.configuraciones.find(item => item.id === this.itemSelectId)
                }
                return {
                    id: 0,
                    key: '',
                    label: '',
                    value: '',
                    type: ''
                }
            }
        },

        watch: {
            dialog(val) {
                val || this.close()
            }
        },

        created() {
            this.initialize()
        },
        mounted() {
            this.encabezadosTabs();
        },
        methods: {
            changeConfig(type) {
                this.options.group_by = type;
                this.configuraciones = [];
                this.listar()
            },
            initialize() {
            },
            close() {
                this.dialog = false;
                this.itemSelectId = 0;
            },
            editItemId(itemId) {
                this.itemSelectId = parseInt(itemId);
                this.dialog = true
            },
            deleteItem() {
                this.loading_delete = true;
                axios.post(`api/configuraciones/eliminar/${this.itemDelete.id}`)
                    .then(({ data }) => {
                        this.loading_delete = false;
                        if (data.success) {
                            this.$_showMessage(data.message);
                            this.dialog_delete = false;
                            this.listar();
                        }
                    })
                    .catch(error => {
                        this.loading_delete = false;
                        if (error.response && error.response.data) {
                            this.$_showError(error.response.data.message);
                        } else {
                            this.$_showError('Error durante la petición');
                        }
                    })
            },
            deleteItemConfirm(item) {
                this.itemDelete = item;
                this.dialog_delete = true;
            },
            encabezadosTabs() {
                axios.get('/api/configuraciones/tipos')
                    .then(({ data }) => {
                        this.encabezados = Object.entries(data).map(item => {
                            return {
                                id: item[1],
                                nombre: item[0]
                            };
                        });
                    })
            },
            listar() {
                this.loading = true;
                const { sortBy, descending, page, itemsPerPage, group_by } = this.options;
                axios.get('/api/configuraciones/listar', {
                    params: {
                        sortBy: sortBy,
                        descending: descending,
                        page: page,
                        rowsPerPage: itemsPerPage,
                        group_by: group_by,
                        search: this.search
                    }
                })
                    .then(({ data }) => {
                        this.configuraciones = data.data.map(config => {
                            if (config.settings.type == "boolean") {
                                config.settings.options = [
                                    {value: '0', text: 'No'},
                                    {value: '1', text: 'Sí'},
                                ]
                            }
                            return config
                        });
                        this.loading = false;
                        this.options.page = data.current_page;
                        this.configuracionesTotal = data.total;
                    })
            },
            saveItem() {
                this.dialog = false;
                this.listar();
            }
        }
    }
</script>

<style scoped>

</style>
